export const PROFILE_URL = '/profile';